import script from "./GPU.vue?vue&type=script&lang=ts&setup=true"
export * from "./GPU.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__